import type { iMSAL, Options } from "./src/types";
import { MSAL } from "./src/main";

export let globalMSALInstance: iMSAL | null = null;

export const setGlobalMSALInstance = (instance: iMSAL): void => {
  globalMSALInstance = instance;
};

export default class msalPlugin {
  static install(app: any, options: Options): void {
    app.config.globalProperties.$msal = new msalPlugin(options);
  }

  constructor(options: Options) {
    const msal = new MSAL(options);
    globalMSALInstance = msal;

    const exposed: iMSAL = {
      data: msal.data,
      async init() {
        return msal.init();
      },
      async signIn(redirectUri: string | undefined) {
        return msal.signIn(redirectUri);
      },
      async signOut() {
        return msal.signOut();
      },
      async acquireToken() {
        return msal.acquireToken();
      },
      async acquireTokenForce(retries: number) {
        return msal.acquireTokenForce(retries);
      },
      isAuthenticated() {
        return msal.isAuthenticated();
      }
    };

    return exposed;
  }
}
